﻿export function parseTrCurrency(value) {
    if (!value) return 0;

    const normalized = value
        .toString()
        .replace(/\./g, "")
        .replace(",", ".");

    const number = parseFloat(normalized);
    return Number.isNaN(number) ? 0 : number;
}